import apiClient from './apiClient'
import type {
  GetBookmarksResponse,
  ApiBookmark,
  CreateBookmarkRequest,
  SyncBookmarksRequest,
  SyncBookmarksResponse,
} from '@/types/api'

/**
 * GET /api/bookmarks
 * Get all bookmarks for the current user.
 */
export async function fetchBookmarks(): Promise<GetBookmarksResponse> {
  const { data } = await apiClient.get<GetBookmarksResponse>('/bookmarks')
  return data
}

/**
 * POST /api/bookmarks
 * Create a bookmark. Idempotent — returns existing if already bookmarked.
 */
export async function createBookmark(
  request: CreateBookmarkRequest
): Promise<ApiBookmark> {
  const { data } = await apiClient.post<ApiBookmark>('/bookmarks', request)
  return data
}

/**
 * DELETE /api/bookmarks/{id}
 * Remove a bookmark. Returns 204 No Content.
 */
export async function deleteBookmark(id: number): Promise<void> {
  await apiClient.delete(`/bookmarks/${id}`)
}

/**
 * POST /api/bookmarks/sync
 * Sync a batch of bookmark changes (create/delete). Returns the full current list.
 */
export async function syncBookmarks(
  request: SyncBookmarksRequest
): Promise<SyncBookmarksResponse> {
  const { data } = await apiClient.post<SyncBookmarksResponse>('/bookmarks/sync', request)
  return data
}
